import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpParams,
  HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { IStockFutureResponse } from 'app/core/interfaces/stock-future-list.interface';
import {
  Future,
  Instrument
} from '@iv/model/instrument';
import { map } from 'rxjs/operators';

@Injectable()
export class AdvancedSearchHttpService {

  constructor(private readonly http: HttpClient) { }

  public getListEntities(params: HttpParams, isFuture: boolean): Observable<IStockFutureResponse<Instrument[] | Future[]>> {
    const endpoint = isFuture ? '/futures-monitor/lookup' : '/lookup/';

    return this.http.get<IStockFutureResponse<Instrument[] | Future[]>>(endpoint, {observe: 'response', params: params})
      .pipe(map((res: HttpResponse<IStockFutureResponse<Instrument[] | Future[]>>) => res.body));
  }
}
